import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const firmPolicy = createCrudVuexModule({
  namespaced: true,
  path: "/policy/firm",
  state: {
    isDownloading: false,
    detailPagination: undefined,
    isDetailLoading: false,
    overview: undefined,
    isOverviewLoading: false,
    firmDashboardDetail: undefined,
    isFirmDashboardDetailLoading: false,
  },
  getters: {
    isDownloading: (state) => state.isDownloading,
    detailPagination: (state) => state.detailPagination,
    isDetailLoading: (state) => state.isDetailLoading,
    overview: (state) => state.overview,
    isOverviewLoading: (state) => state.isOverviewLoading,
    firmDashboardDetail: (state) => state.firmDashboardDetail,
    isFirmDashboardDetailLoading: (state) => state.isFirmDashboardDetailLoading,
  },
  mutations: {
    isDownloading: (state, value) => (state.isDownloading = value),
    detailPagination: (state, value) => (state.detailPagination = value),
    isDetailLoading: (state, value) => (state.isDetailLoading = value),
    overview: (state, value) => (state.overview = value),
    isOverviewLoading: (state, value) => (state.isOverviewLoading = value),
    firmDashboardDetail: (state, value) => (state.firmDashboardDetail = value),
    isFirmDashboardDetailLoading: (state, value) => (state.isFirmDashboardDetailLoading = value),
  },
  actions: {
    async fetchOverview({ commit }, payload = {}) {
      commit("isOverviewLoading", true);
      try {
        const response = await rest.post("/dashboard/fwsed/overview", payload);
        commit("overview", response.data);
        return response;
      } finally {
        commit("isOverviewLoading", false);
      }
    },
    async fetchFirmControlPolicy({ commit }, { firmId, auditId, pagination = {} } = {}) {
      if (!firmId) {
        commit("detailPagination", undefined);

        return;
      }

      if (!auditId) {
        commit("detailPagination", undefined);

        return;
      }
      commit("isDetailLoading", true);
      try {
        const response = await rest.post(`/policy/firm/${firmId}/audit/${auditId}/paginate`, { pagination });
        commit("detailPagination", response.data);

        return response;
      } finally {
        commit("isDetailLoading", false);
      }
    },
    async fetchFirmDashboardDetail({ commit }, { firmId } = {}) {
      if (!firmId) {
        commit("firmDashboardDetail", undefined);
        return;
      }
      commit("isFirmDashboardDetailLoading", true);
      try {
        const response = await rest.post(`/dashboard/fwsed/firm/${firmId}/detail`);
        commit("firmDashboardDetail", response.data);
        return response;
      } finally {
        commit("isFirmDashboardDetailLoading", false);
      }
    },

    async prepareFindeksByFirm({ commit }, { firm, audit }) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/policy/download/findeks-by-firm", { firmId: firm._id, auditId: audit._id });
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
  },
});
